const basePath = process.env.PUBLIC_URL || "";
const transportPath = `${basePath}/transport`;

// API Configuration from Environment
const API_URL = process.env.REACT_APP_API_URL || 'https://www.nody.it/backend';

// Brand Configuration
const brandFolder = process.env.REACT_APP_BRAND_FOLDER || "nody";
const useIconInHeader = process.env.REACT_APP_USE_ICON_IN_HEADER === 'true';

// Image Filenames Configuration from Environment
const imageFilenames = {
  logo: process.env.REACT_APP_LOGO_FILENAME || process.env.REACT_APP_ICON_FILENAME || 'logo.png',
  icon: process.env.REACT_APP_ICON_FILENAME || 'icon.png',
  favicon: process.env.REACT_APP_FAVICON_FILENAME || process.env.REACT_APP_ICON_FILENAME || 'favicon.ico',
  // Se esiste la variabile specifica usa quella, altrimenti fallback a ICON
  logo192: process.env.REACT_APP_LOGO192_FILENAME || process.env.REACT_APP_ICON_FILENAME || 'icon.png',
  logo512: process.env.REACT_APP_LOGO512_FILENAME || process.env.REACT_APP_ICON_FILENAME || 'icon.png',
  maskableIcon: process.env.REACT_APP_MASKABLE_ICON_FILENAME || process.env.REACT_APP_ICON_FILENAME || 'icon.png',
  qrcode: process.env.REACT_APP_QRCODE_FILENAME || 'qr_code.jpg'
};

// sopra ai styled:
const IMG_HOME_WIDTH_MOBILE = (() => {
  const v = process.env.REACT_APP_IMG_HOME;
  if (!v) return '60%';
  return /^\d+$/.test(v) ? `${v}%` : v; // consente "60" -> "60%", o "320px", ecc.
})();
// Dynamic Assets Paths
const getAssetPath = (filename) => `${basePath}/assets/${brandFolder}/${filename}`;

// Languages Configuration from Environment
const parseLanguages = () => {
  const defaultLang = process.env.REACT_APP_DEFAULT_LANGUAGE || "it";
  const availableLanguages = process.env.REACT_APP_AVAILABLE_LANGUAGES || "it,en,fr";
  const languageLabels = process.env.REACT_APP_LANGUAGE_LABELS || '{"it":"Italiano","en":"English","fr":"Français"}';
  
  const availableArray = availableLanguages.split(',');
  const labelsObj = JSON.parse(languageLabels);
  
  const available = {};
  availableArray.forEach(lang => {
    if (labelsObj[lang]) {
      available[lang] = labelsObj[lang];
    }
  });
  
  return {
    default: defaultLang,
    available: available
  };
};

const languages = parseLanguages();

// App Configuration from Environment
const app = {
  name: process.env.REACT_APP_NAME || "Nody",
  shortName: process.env.REACT_APP_SHORT_NAME || "Nody",
  title: process.env.REACT_APP_TITLE || "Nody",
  description: process.env.REACT_APP_DESCRIPTION || "Nody Progressive Web App",
  url: process.env.REACT_APP_URL || window.location.origin,
  themeColor: process.env.REACT_APP_THEME_COLOR || "#000000",
  backgroundColor: process.env.REACT_APP_BACKGROUND_COLOR || "#ffffff",
  lang: process.env.REACT_APP_LANG || "it",
  orientation: process.env.REACT_APP_ORIENTATION || "portrait-primary",
  categories: process.env.REACT_APP_CATEGORIES ? process.env.REACT_APP_CATEGORIES.split(',') : ["utility"]
};

// Components Configuration from Environment
const parseBoolean = (value, defaultValue = false) => {
  if (value === undefined || value === null) return defaultValue;
  return value === 'true';
};

const components = {
  map: parseBoolean(process.env.REACT_APP_COMPONENT_MAP, true),
  routes: parseBoolean(process.env.REACT_APP_COMPONENT_ROUTES, false),
  transport: parseBoolean(process.env.REACT_APP_COMPONENT_TRANSPORT, false),
  poiSlider: parseBoolean(process.env.REACT_APP_COMPONENT_POI_SLIDER, true),
  listType: process.env.REACT_APP_COMPONENT_LIST_TYPE || 'tiny',
  password: {
    enabled: parseBoolean(process.env.REACT_APP_PASSWORD_ENABLED, false),
    endpoint: process.env.REACT_APP_PASSWORD_ENDPOINT || '/api/activate-password',
    maxAttempts: parseInt(process.env.REACT_APP_PASSWORD_MAX_ATTEMPTS) || 3,
    lockoutDuration: parseInt(process.env.REACT_APP_PASSWORD_LOCKOUT_DURATION) || 300000,
  },
  wall: parseBoolean(process.env.REACT_APP_COMPONENT_WALL, true),
  search: {
    enabled: parseBoolean(process.env.REACT_APP_COMPONENT_SEARCH, true)
  },
  nearbyPlaces: {
    enabled: parseBoolean(process.env.REACT_APP_COMPONENT_NEARBY_PLACES, true)
  },
  extra: parseBoolean(process.env.REACT_APP_COMPONENT_EXTRA, false),
  qrcode: parseBoolean(process.env.REACT_APP_COMPONENT_QRCODE, true)
};

// JWT Configuration
const JWT_CONFIG = {
  endpoint: `${API_URL}/jwt/token`,
  credentials: {
    username: process.env.REACT_APP_API_USERNAME,
    password: process.env.REACT_APP_API_PASSWORD
  }
};

// API Endpoints
const API_ENDPOINTS = {
  getNode: (nodeId, lang) => `${API_URL}/node/${nodeId}?_format=json&language_content_entity=${lang}`,
  getMedia: (mediaId, lang) => `${API_URL}/media/${mediaId}?_format=json&language_content_entity=${lang}`,
  getParagraph: (paragraphId, lang) => `${API_URL}/api/paragraph/${paragraphId}/translation?lang=${lang}`,
  getPercorsiList: (lang) => `${API_URL}/percorsi/list?lang=${lang}`,
  getPageList: (lang) => `${API_URL}/page/list?lang=${lang}`,
  getPOIList: (lang) => `${API_URL}/poi/list?lang=${lang}`,
  getTaxonomyTerm: (taxonomyId, lang) => `${API_URL}/taxonomy/term/${taxonomyId}?_format=json&language_content_entity=${lang}`,
};

// Asset Paths - tutto da assets/brandFolder, fallback robusti a REACT_APP_ICON_FILENAME
const assets = {
  logo: `${basePath}/assets/${brandFolder}/${imageFilenames.logo}`,
  icon: `${basePath}/assets/${brandFolder}/${imageFilenames.icon}`,
  favicon: `${basePath}/assets/${brandFolder}/${imageFilenames.favicon}`,
  logo192: `${basePath}/assets/${brandFolder}/${imageFilenames.logo192}`,
  logo512: `${basePath}/assets/${brandFolder}/${imageFilenames.logo512}`,
  maskableIcon: `${basePath}/assets/${brandFolder}/${imageFilenames.maskableIcon}`,
  qrcode: `${basePath}/assets/${brandFolder}/${imageFilenames.qrcode}`,
  // Helper function to get the right image for header
  getHeaderImage: () => useIconInHeader ? assets.icon : assets.logo
};

const config = {
  basePath,
  transportPath,
  API_URL,
  API_ENDPOINTS,
  languages,
  app,
  components,
  JWT_CONFIG,
  assets,
  brandFolder,
  useIconInHeader,
  imageFilenames,
  // Analytics
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS || 'false',
  GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GA_MEASUREMENT_ID,
};

export default config;